import ProgressStatus from './component.jsx'
export default ProgressStatus
